import { useState, useEffect } from "react";
import axios from "axios";

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

ChartJS.register(ArcElement, Tooltip, Legend);

const CategorizingFamilyComponent = () => {
  const [families, setFamilies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //Error Logging Service
  const [{ errorLogApi, user }] = useAtom(gbState);
  // Count males and females
  let maleCount = 0;
  let femaleCount = 0;

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          setFamilies(response.data.families);
          setIsLoading(false);
        })
        .catch(function (err) {
          console.log("error api call ", err);
          setIsLoading(false);
        });
    };
    getDataFromServer();
  }, []);

  families.forEach((family) => {
    // Count primary member
    if (family.gender === "male") {
      maleCount++;
    } else if (family.gender === "female") {
      femaleCount++;
    }

    // Count family members
    family.family_member?.forEach((member) => {
      if (member.gender === "male") {
        maleCount++;
      } else if (member.gender === "female") {
        femaleCount++;
      }
    });
  });

  const data = {
    labels: ["Male", "Female"],
    datasets: [
      {
        data: [maleCount, femaleCount],
        backgroundColor: [
          "rgba(54, 162, 235, 0.8)", // blue for male
          "rgba(255, 99, 132, 0.8)", // pink for female
        ],
        borderColor: ["rgba(54, 162, 235, 1)", "rgba(255, 99, 132, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Gender Distribution",
        font: {
          size: 16,
        },
      },
    },
    maintainAspectRatio: false,
  };

  // After counting males and females
  const hasData = maleCount > 0 || femaleCount > 0;

  return (
    <div style={{ height: "300px", width: "100%" }}>
      {isLoading ? (
        <div className="flex items-center justify-center h-full">
          Loading...
        </div>
      ) : hasData ? (
        <Doughnut data={data} options={options} />
      ) : (
        <div className="flex items-center justify-center h-full text-lg text-gray-500">
          No family data available. Add some families to see the gender
          distribution.
        </div>
      )}
    </div>
  );
};

export default CategorizingFamilyComponent;
